// The Overseas Sales guide (66_SalesByBuyer.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'Three views of the same sales',
  tabsB: 'Dashboard gives the summary, Buyer table lists the USD billed per buyer and month, and YoY compares two years. Click a tab to switch.',
  dashT: 'Dashboard filters',
  dashB: 'Narrow the dashboard by year, month, category, country or buyer. Leave a filter on All to see everything.',
  toolsT: 'Buyer table controls',
  toolsB: 'Choose the year, search by region, country, pricing or buyer, hide buyers with no sales, and download Excel. If you may load data, a month picker and the SAP read button are here too.',
  tableT: 'Buyer by month',
  tableB: 'One row per buyer with the USD billed each month and a total. Months marked SAP were read from SAP, the others come from the workbook. Click a heading to sort or filter, and a SAP amount to see its documents.',
  yoyT: 'Year over year',
  yoyB: 'Pick two years to put side by side and see how each month, country and buyer changed.',
  osT: 'Order Status data',
  osB: 'Every row of the newest Order Status file. Scroll down through all of them; every header sorts and filters like Excel, and Excel downloads what is shown. If you may upload, the Upload Order Status button is at the right end of the tab bar.',
};
const ko = {
  tabsT: '같은 매출의 세 가지 화면',
  tabsB: 'Dashboard는 요약, Buyer table은 바이어·월별 USD 청구액, YoY는 두 해의 비교입니다. 탭을 클릭해 전환하세요.',
  dashT: 'Dashboard 필터',
  dashB: '연도, 월, 카테고리, 국가, 바이어로 Dashboard를 좁힙니다. 필터를 All로 두면 전체가 보입니다.',
  toolsT: 'Buyer table 조작',
  toolsB: '연도를 고르고, 지역·국가·가격 구분·바이어로 검색하고, 매출이 없는 바이어를 숨기고, Excel을 내려받습니다. 데이터를 불러올 권한이 있으면 월 선택과 SAP 읽기 버튼도 여기에 있습니다.',
  tableT: '바이어별 월 매출',
  tableB: '바이어마다 한 행으로 월별 USD 청구액과 합계가 표시됩니다. SAP 표시가 있는 달은 SAP에서 읽은 값이고, 나머지는 워크북 값입니다. 제목을 클릭해 정렬·필터하고, SAP 금액을 클릭하면 문서를 볼 수 있습니다.',
  yoyT: '전년 대비',
  yoyB: '비교할 두 해를 골라 월별, 국가별, 바이어별 변화를 나란히 확인합니다.',
  osT: 'Order Status 데이터',
  osB: '최신 Order Status 파일의 모든 행입니다. 아래로 스크롤해 전부 볼 수 있고, 모든 열 머리글에서 Excel처럼 정렬·필터하며, Excel은 보이는 행을 내려받습니다. 업로드 권한이 있으면 탭 줄 오른쪽 끝에 Order Status 업로드 버튼이 있습니다.',
};
const vi = {
  tabsT: 'Ba cách xem cùng một số liệu bán hàng',
  tabsB: 'Dashboard là bản tóm tắt, Buyer table liệt kê số USD đã xuất hóa đơn theo buyer và tháng, còn YoY so sánh hai năm. Bấm vào tab để chuyển.',
  dashT: 'Bộ lọc của Dashboard',
  dashB: 'Thu hẹp dashboard theo năm, tháng, nhóm hàng, quốc gia hoặc buyer. Để bộ lọc ở All là xem tất cả.',
  toolsT: 'Công cụ của Buyer table',
  toolsB: 'Chọn năm, tìm theo vùng, quốc gia, pricing hoặc buyer, ẩn buyer chưa có doanh số, và tải Excel. Nếu bạn được phép load dữ liệu thì ở đây còn có ô chọn tháng và nút đọc SAP.',
  tableT: 'Buyer theo tháng',
  tableB: 'Mỗi dòng là một buyer với số USD xuất hóa đơn từng tháng và tổng. Tháng có nhãn SAP là số đọc từ SAP, các tháng còn lại lấy từ workbook. Bấm tiêu đề cột để sắp xếp hoặc lọc, bấm một số tiền SAP để xem các chứng từ.',
  yoyT: 'So sánh theo năm',
  yoyB: 'Chọn hai năm để đặt cạnh nhau và xem từng tháng, quốc gia, buyer thay đổi ra sao.',
  osT: 'Dữ liệu Order Status',
  osB: 'Mọi dòng của file Order Status mới nhất. Cuộn xuống để xem hết; tiêu đề mỗi cột sắp xếp và lọc như Excel, nút Excel tải đúng những dòng đang hiện. Nếu anh chị có quyền tải lên, nút Tải lên Order Status ở cuối hàng tab bên phải.',
};
const zh = {
  tabsT: '同一销售数据的三种视图',
  tabsB: 'Dashboard 是汇总，Buyer table 列出每个 buyer 每月开票的 USD 金额，YoY 对比两个年份。点击标签即可切换。',
  dashT: 'Dashboard 筛选',
  dashB: '按年份、月份、品类、国家或 buyer 缩小看板范围。筛选保持 All 即查看全部。',
  toolsT: 'Buyer table 工具',
  toolsB: '选择年份，按地区、国家、pricing 或 buyer 搜索，隐藏没有销售的 buyer，并下载 Excel。如果您有权加载数据，这里还有月份选择和 SAP 读取按钮。',
  tableT: '按月的 buyer 明细',
  tableB: '每个 buyer 一行，显示每月开票的 USD 金额和合计。标有 SAP 的月份来自 SAP，其余来自工作簿。点击表头可排序或筛选，点击 SAP 金额可查看其单据。',
  yoyT: '同比',
  yoyB: '选择两个年份并排对比，查看各月、各国家、各 buyer 的变化。',
  osT: 'Order Status 数据',
  osB: '最新 Order Status 文件的所有行。向下滚动即可查看全部；每个列标题都可像 Excel 一样排序和筛选，Excel 按钮下载当前显示的行。如有上传权限，上传 Order Status 按钮在标签栏右端。',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "tabsT": "Trois vues des mêmes ventes",
  "tabsB": "Tableau de bord donne la synthèse, Par acheteur et pays liste les USD facturés par acheteur et par mois, et Année sur année compare deux années. Cliquez sur un onglet pour changer.",
  "dashT": "Filtres du tableau de bord",
  "dashB": "Affinez le tableau de bord par année, mois, catégorie, pays ou acheteur. Laissez un filtre sur « Tout » pour tout voir.",
  "toolsT": "Commandes du tableau des acheteurs",
  "toolsB": "Choisissez l'année, recherchez par région, pays, tarification ou acheteur, masquez les acheteurs sans ventes et téléchargez Excel. Si vous pouvez charger des données, un sélecteur de mois et le bouton de lecture SAP se trouvent aussi ici.",
  "tableT": "Acheteur par mois",
  "tableB": "Une ligne par acheteur avec les USD facturés chaque mois et un total. Les mois marqués SAP ont été lus depuis SAP, les autres viennent du classeur. Cliquez sur un en-tête pour trier ou filtrer, et sur un montant SAP pour voir ses documents.",
  "yoyT": "D'une année sur l'autre",
  "yoyB": "Choisissez deux années à comparer côte à côte et voyez comment ont évolué chaque mois, chaque pays et chaque acheteur.",
  "osT": "Données Order Status",
  "osB": "Chaque ligne du fichier Order Status le plus récent. Faites défiler pour toutes les voir ; chaque en-tête trie et filtre comme dans Excel, et Excel télécharge ce qui est affiché. Si vous pouvez importer, le bouton Importer Order Status se trouve à l'extrémité droite de la barre d'onglets."
};
const ja = {
  "tabsT": "同じ売上の3つのビュー",
  "tabsB": "「ダッシュボード」はサマリー、「バイヤー・国別」はバイヤー別・月別の請求額（USD）、「前年比」は2つの年の比較です。タブをクリックして切り替えます。",
  "dashT": "ダッシュボードのフィルター",
  "dashB": "年、月、カテゴリー、国、バイヤーでダッシュボードを絞り込みます。すべて表示するには、フィルターを「すべて」のままにしてください。",
  "toolsT": "バイヤー表の操作",
  "toolsB": "年を選び、地域、国、価格設定、バイヤーで検索し、売上のないバイヤーを非表示にして、Excel をダウンロードできます。データを読み込む権限がある場合は、月の選択と SAP 読み込みボタンもここにあります。",
  "tableT": "バイヤー別・月別",
  "tableB": "バイヤーごとに1行で、各月の請求額（USD）と合計を表示します。SAP と表示された月は SAP から読み込まれたもので、その他はブックのデータです。見出しをクリックして並べ替えや絞り込みを行い、SAP の金額をクリックするとその伝票を確認できます。",
  "yoyT": "前年比",
  "yoyB": "2つの年を並べて比較し、月、国、バイヤーごとにどう変化したかを確認します。",
  "osT": "Order Status データ",
  "osB": "最新の Order Status ファイルのすべての行です。下にスクロールしてすべて確認できます。各見出しで Excel と同じように並べ替えと絞り込みができ、「Excel」で表示中の内容をダウンロードします。アップロード権限がある場合は、タブバーの右端に「Order Status をアップロード」ボタンがあります。"
};

const dictionary = { ns: 'tourOverseas', en, ko, vi, zh, fr, ja };
export default dictionary;
